<template>
  <div class="grid-default container py-2">
    <div class="col-span-6 mb-8 lg:mb-0">
      <Heading :level="1" is-hero-heading class="mb-4 text-5xl font-light text-blue-950 lg:mb-8 lg:text-9xl">
        {{ data.title }}
      </Heading>
      <div class="text-base text-neutral-600 lg:text-2xl" v-html="data.descriptionText" />
    </div>
    <Image
      v-if="data.heroImage"
      class="col-span-6 aspect-3/2 w-full rounded-3xl object-cover opacity-100"
      :src="
        data.heroImage.responsiveImage ? data.heroImage.responsiveImage?.src : data.heroImage.url
      "
      :srcset="
        data.heroImage.responsiveImage ? data.heroImage.responsiveImage?.webpSrcSet : undefined
      "
      :width="
        data.heroImage.responsiveImage
          ? data.heroImage.responsiveImage?.width
          : data.heroImage.width
      "
      :height="
        data.heroImage.responsiveImage
          ? data.heroImage.responsiveImage?.height
          : data.heroImage.height
      "
      :sizes="data.heroImage.responsiveImage?.sizes"
      :alt="data.heroImage.alt!"
    />
  </div>
</template>

<script setup lang="ts">
import { ProductDetailHeroRecord } from '~/types/generated'
import { useAppStore } from '~/stores/AppStore'

const store = useAppStore()

defineProps({
  data: {
    type: Object as PropType<ProductDetailHeroRecord>,
    default: () => {}
  }
})

onMounted(() => {
  store.setTheme('neutral')
})
</script>
